import { marker as T } from '@biesbjerg/ngx-translate-extract-marker';

export const invalidDate = T('Invalid Date');
